import { SHOP_PRODUCTS_PATH } from '@constant'
import { HeaderView } from '@merchant-backend/common-components'
import { isUltimate } from '@merchant-backend/util'
import { isTelSaleCityMerchant } from '@util'
import React, { Component, Fragment } from 'react'
import { Link } from 'react-router'
import Style from './index.module.less'

export default class extends Component {
  render() {
    return (
      <HeaderView title="潜在客资转化">
        <div className={Style.content}>
          <img src="//qnm.hunliji.com/o_1cn6nmu7v1mae9u77262512bcj.jpg" />
          <img src="//qnm.hunliji.com/o_1cn6nmu7v1795qa81v6o1u8416qvk.jpg" />
          <img src="//qnm.hunliji.com/o_1cn6nmu7v7vd1segs3im0ftq7l.jpg" />
          <img src="//qnm.hunliji.com/o_1cn6nmu7vnsh10su5no128o13lam.jpg" />
          <img src="//qnm.hunliji.com/o_1cn6nmu7v795ufg1digkd01ohvn.jpg" />
          {isUltimate() ? (
            <Fragment>
              <Link to="/localMerchant/potentialCustomers">
                <img src="//qnm.hunliji.com/o_1cn6nmu7v11rk1ovktnet566mfr.jpg" />
              </Link>
              <img src="//qnm.hunliji.com/o_1cn6nmu7v1t8je7pnbr12c9f7is.jpg" />
              <img src="//qnm.hunliji.com/o_1cn6nmu7vi9gaa11v9s17ulmgt.jpg" />
            </Fragment>
          ) : (
            <Fragment>
              <img
                src={
                  isTelSaleCityMerchant()
                    ? '//qnm.hunliji.com/o_1dq0o5h0naqi19a517dpsu43n4b.jpg'
                    : '//qnm.hunliji.com/o_1cn6nmu7vpjm1t8m1vpg2f513a1o.jpg'
                }
              />
              <Link to={SHOP_PRODUCTS_PATH}>
                <img
                  src={
                    isTelSaleCityMerchant()
                      ? '//qnm.hunliji.com/o_1dq0o5h0n12bue211br13qm1hga.jpg'
                      : '//qnm.hunliji.com/o_1cn6nmu7v1qoq177srcf1hfk1b5vp.jpg'
                  }
                />
              </Link>
              <img src="//qnm.hunliji.com/o_1cn6nmu7vpaqm3sucqmqf1uu6q.jpg" />
            </Fragment>
          )}
        </div>
      </HeaderView>
    )
  }
}
